// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import AMap from 'vue-amap'
Vue.use(AMap)

//  router.afterEach((to, from, next) => {
//  window.scrollTo(0, 0)
//  })

AMap.initAMapApiLoader({
  key: '4c49ed8a642e071fcf777693dbf152b2',
  plugin: ['AMap.Geolocation']
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js